"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var HideEntireReportController = /** @class */ (function () {
    function HideEntireReportController(
    // @ts-ignore
    $scope, 
    // @ts-ignore
    triggerOverrides, 
    // @ts-ignore
    OVERRIDE_EVENTS) {
        this.$scope = $scope;
        this.triggerOverrides = triggerOverrides;
        this.OVERRIDE_EVENTS = OVERRIDE_EVENTS;
        $scope.$ctrl = this;
    }
    HideEntireReportController.prototype.$onInit = function () {
        var configFlags = this.triggerOverrides({
            event: this.OVERRIDE_EVENTS.CONFIG_FLAGS,
            sync: true,
            data: {}
        });
        this.showLanguagePicker = !lodash_1.default.get(configFlags, 'disableLanguagePicker', false);
    };
    HideEntireReportController.$inject = [
        '$scope',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS'
    ];
    return HideEntireReportController;
}());
(function (angularModule) {
    angularModule.controller('prHideEntireReportController', HideEntireReportController);
})(angular_1.default.module('qualtrics.pr'));
